/* ShubVibes PDP — variant selection + AJAX add-to-cart (opens Dawn's drawer). */
(function () {
  'use strict';

  function money(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  // The struck-through compare-at price reads "MRP 999.00", not "Rs. 999.00".
  // Liquid already emits it prefixed in compare_formatted; this only has to cover the
  // fallback path, and stays idempotent so it can never produce "MRP MRP ...".
  function mrpLabel(cents, format, preformatted) {
    var s = preformatted || money(cents, format);
    if (s.indexOf('MRP') === 0) return s;
    return 'MRP ' + s.replace(/^\s*(Rs\.?|₹|INR)\s*/i, '');
  }

  function initPDP(root) {
    var dataEl = root.querySelector('[data-sv-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('.sv-pdp__form') || root.querySelector('form');
    var idInput = root.querySelector('[data-sv-variant-id]');
    var priceEl = root.querySelector('[data-sv-price]');
    var compareEl = root.querySelector('[data-sv-compare]');
    var colorLabel = root.querySelector('[data-sv-color-label]');
    var addBtn = root.querySelector('[data-sv-add]');
    var addText = addBtn ? addBtn.querySelector('[data-sv-add-text]') : null;
    var moneyFormat = root.getAttribute('data-money-format') || '';
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[data-sv-opt]'));
    var lowStockEl = root.querySelector('[data-sv-lowstock]');
    var lowStockText = lowStockEl ? lowStockEl.querySelector('[data-sv-lowstock-text]') : null;
    // Bundle & Save — the selected tier drives the add-to-cart quantity (pending §6).
    var qtyInput = root.querySelector('[data-sv-quantity]');
    var bundleRadios = Array.prototype.slice.call(root.querySelectorAll('[data-sv-bundle-tier]'));
    var bundleQty = 1;
    function selectedBundleQty() {
      var r = bundleRadios.find(function (x) { return x.checked; });
      return r ? (parseInt(r.getAttribute('data-qty'), 10) || 1) : 1;
    }
    // Per-item pickers: every tee in the bundle picks its own colour/size and
    // goes to the cart as a separate line item. Slot 1 mirrors the main swatches.
    var bundlePicks = root.querySelector('[data-sv-bundle-picks]');
    var bundleSlots = Array.prototype.slice.call(root.querySelectorAll('[data-sv-bundle-slot]'));
    var primarySlot = root.querySelector('[data-sv-bundle-slot="1"]');

    function slotSelects(slot) {
      return Array.prototype.slice.call(slot.querySelectorAll('[data-sv-bundle-opt]'));
    }

    function syncBundleQty() {
      bundleQty = selectedBundleQty();
      // The quantity input only matters for the no-drawer fallback, where a
      // native form POST can carry one variant; the AJAX path builds real items.
      if (qtyInput) qtyInput.value = bundleQty;
      if (bundlePicks) bundlePicks.hidden = bundleQty < 2;
      bundleSlots.forEach(function (s) {
        var n = parseInt(s.getAttribute('data-sv-bundle-slot'), 10) || 99;
        // Hide every slot below tier 2 so activeSlots() is empty and a single
        // purchase cannot pick up a slot variant.
        s.hidden = bundleQty < 2 || n > bundleQty;
      });
    }

    // Main swatches -> slot 1. Setting .value programmatically fires no change
    // event, so this cannot loop back into applyPrimaryToMain.
    function syncPrimaryFromMain() {
      if (!primarySlot) return;
      var sel = currentSelections();
      slotSelects(primarySlot).forEach(function (s) {
        var pos = s.getAttribute('data-sv-bundle-opt');
        if (sel[pos] != null) s.value = sel[pos];
      });
    }

    // Slot 1 -> main swatches, so the gallery, price and low-stock note all
    // follow. Without this the PDP could show Black while Tee 1 said White.
    function applyPrimaryToMain() {
      if (!primarySlot) return;
      slotSelects(primarySlot).forEach(function (s) {
        var pos = s.getAttribute('data-sv-bundle-opt');
        radios.forEach(function (r) {
          if (r.getAttribute('data-sv-opt') === pos) r.checked = (r.value === s.value);
        });
      });
    }

    function activeSlots() {
      return bundleSlots.filter(function (s) { return !s.hidden; });
    }

    function slotVariant(slot) {
      var sel = {};
      slotSelects(slot).forEach(function (s) {
        sel[s.getAttribute('data-sv-bundle-opt')] = s.value;
      });
      return findVariant(sel);
    }

    // Every slot must resolve to a purchasable variant, or the whole add fails
    // server-side with no useful message. Flag the offending slot instead.
    function slotsOk() {
      var ok = true;
      activeSlots().forEach(function (slot) {
        var v = slotVariant(slot);
        var bad = !v || !v.available;
        var warn = slot.querySelector('[data-sv-bundle-slotwarn]');
        if (warn) warn.hidden = !bad;
        if (bad) ok = false;
      });
      return ok;
    }

    function bundleItems() {
      var slots = activeSlots();
      // Below tier 2 every slot is hidden, so fall back to the main selection.
      if (!slots.length) return [{ id: idInput.value, quantity: 1 }];
      // Slot 1 mirrors the main selection, so taking it from the slots avoids
      // adding the first tee twice.
      return slots.map(function (slot) {
        var v = slotVariant(slot);
        return { id: v ? String(v.id) : idInput.value, quantity: 1 };
      });
    }

    // ---- Gallery: thumbnail rail + stage (desktop) / swipe slider (mobile) (§2) ----
    var stageEl = root.querySelector('[data-sv-stage]');
    var thumbsEl = root.querySelector('[data-sv-thumbs]');
    var dotsEl = root.querySelector('[data-sv-dots]');
    var lastGalleryColor = null;
    var mqMobile = window.matchMedia('(max-width:989px)');

    function stageMediaAll() { return stageEl ? Array.prototype.slice.call(stageEl.querySelectorAll('[data-sv-media-id]')) : []; }
    function thumbsAll() { return thumbsEl ? Array.prototype.slice.call(thumbsEl.querySelectorAll('[data-sv-thumb]')) : []; }
    function stageMediaVisible() { return stageMediaAll().filter(function (el) { return !el.hidden; }); }

    function markActive(id) {
      id = String(id);
      stageMediaAll().forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-sv-media-id') === id); });
      thumbsAll().forEach(function (t) {
        var on = t.getAttribute('data-sv-thumb') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (dotsEl) Array.prototype.slice.call(dotsEl.children).forEach(function (d) {
        d.classList.toggle('is-active', d.getAttribute('data-sv-dot') === id);
      });
    }
    function setActiveMedia(id, doScroll) {
      markActive(id);
      if (doScroll && stageEl && mqMobile.matches) {
        var target = stageEl.querySelector('[data-sv-media-id="' + id + '"]');
        if (target) stageEl.scrollTo({ left: target.offsetLeft - stageEl.offsetLeft, behavior: 'smooth' });
      }
    }
    function buildDots() {
      if (!dotsEl) return;
      var vis = stageMediaVisible();
      dotsEl.innerHTML = '';
      if (vis.length < 2) return;
      vis.forEach(function (el) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sv-pdp__dot' + (el.classList.contains('is-active') ? ' is-active' : '');
        b.setAttribute('data-sv-dot', el.getAttribute('data-sv-media-id'));
        b.setAttribute('aria-label', 'Show image');
        dotsEl.appendChild(b);
      });
    }
    function filterGalleryByColor(color) {
      stageMediaAll().forEach(function (el) {
        var c = el.getAttribute('data-sv-media-color');
        el.hidden = !(!c || !color || c === color);
      });
      thumbsAll().forEach(function (t) {
        var c = t.getAttribute('data-sv-thumb-color');
        t.hidden = !(!c || !color || c === color);
      });
      if (color !== lastGalleryColor) {
        lastGalleryColor = color;
        var vis = stageMediaVisible();
        if (vis.length) {
          if (stageEl) stageEl.scrollLeft = 0;
          markActive(vis[0].getAttribute('data-sv-media-id'));
        }
      }
      buildDots();
    }

    function updateLowStock(v) {
      if (!lowStockEl) return;
      var threshold = parseInt(lowStockEl.getAttribute('data-threshold'), 10) || 5;
      // Only when Shopify tracks inventory, the variant is in stock, and it's running low.
      if (v && v.available && v.inventory_management === 'shopify' &&
          typeof v.inventory_quantity === 'number' &&
          v.inventory_quantity > 0 && v.inventory_quantity <= threshold) {
        if (lowStockText) {
          lowStockText.textContent = 'Only ' + v.inventory_quantity +
            (v.inventory_quantity === 1 ? ' left in stock' : ' left in stock');
        }
        lowStockEl.hidden = false;
      } else {
        lowStockEl.hidden = true;
      }
    }

    function currentSelections() {
      var sel = {};
      radios.forEach(function (r) {
        if (r.checked) sel[r.getAttribute('data-sv-opt')] = r.value;
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return Object.keys(sel).every(function (pos) {
          return String(v.options[pos - 1]) === sel[pos];
        });
      });
    }

    function refreshAvailability(sel) {
      radios.forEach(function (r) {
        var pos = r.getAttribute('data-sv-opt');
        var trial = Object.assign({}, sel);
        trial[pos] = r.value;
        var match = variants.find(function (v) {
          return Object.keys(trial).every(function (p) { return String(v.options[p - 1]) === trial[p]; });
        });
        var soldOut = !match || !match.available;
        var wrap = r.closest('[data-sv-opt-wrap]');
        if (wrap) wrap.classList.toggle('is-soldout', soldOut);
        // Only truly disable when no such variant exists at all (keep sold-out selectable to show state).
      });
    }

    function update() {
      var sel = currentSelections();
      var v = findVariant(sel);
      refreshAvailability(sel);
      syncPrimaryFromMain();
      updateLowStock(v);

      var colorRadio = radios.find(function (r) { return r.checked && r.getAttribute('data-sv-opt-name') === 'color'; });
      var selectedColor = colorRadio ? colorRadio.value : '';
      if (colorLabel && colorRadio) colorLabel.textContent = selectedColor;

      // Show only the selected colour's gallery images + thumbnails (uncoloured media always show).
      filterGalleryByColor(selectedColor);

      if (!v) {
        if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); }
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_formatted || money(v.price, moneyFormat);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.innerHTML = mrpLabel(v.compare_at_price, moneyFormat, v.compare_formatted);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (addBtn) {
        var picksOk = slotsOk();
        if (v.available && picksOk) {
          addBtn.removeAttribute('disabled');
          if (addText) addText.textContent = bundleQty > 1 ? ('Add ' + bundleQty + ' to Bag') : 'Add to Bag';
        } else if (v.available && !picksOk) {
          // The main variant is fine; a bundle slot is the problem, and its own
          // message says which — keep the button honest rather than "Sold Out".
          addBtn.setAttribute('disabled', 'disabled');
          if (addText) addText.textContent = 'Choose available options';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          if (addText) addText.textContent = 'Sold Out';
        }
      }
      // Swap the stage to the variant's featured media, when it's part of the visible set.
      if (v.featured_media_id) {
        var fm = stageEl && stageEl.querySelector('[data-sv-media-id="' + v.featured_media_id + '"]');
        if (fm && !fm.hidden) setActiveMedia(v.featured_media_id, true);
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    bundleRadios.forEach(function (r) {
      r.addEventListener('change', function () { syncBundleQty(); update(); });
      // Reflect selection on the tier card (checked state styles the wrapper).
      r.addEventListener('change', function () {
        bundleRadios.forEach(function (x) {
          var card = x.closest('.sv-bundle__tier');
          if (card) card.classList.toggle('is-selected', x.checked);
        });
      });
    });
    bundleSlots.forEach(function (slot) {
      var isPrimary = slot === primarySlot;
      slotSelects(slot).forEach(function (s) {
        s.addEventListener('change', function () {
          if (isPrimary) applyPrimaryToMain();
          update();
        });
      });
    });
    syncBundleQty();
    // Set initial selected styling.
    bundleRadios.forEach(function (x) {
      var card = x.closest('.sv-bundle__tier');
      if (card) card.classList.toggle('is-selected', x.checked);
    });

    // Gallery interactions.
    if (thumbsEl) {
      thumbsEl.addEventListener('click', function (e) {
        var t = e.target.closest('[data-sv-thumb]');
        if (t) setActiveMedia(t.getAttribute('data-sv-thumb'), true);
      });
    }
    if (dotsEl) {
      dotsEl.addEventListener('click', function (e) {
        var d = e.target.closest('[data-sv-dot]');
        if (d) setActiveMedia(d.getAttribute('data-sv-dot'), true);
      });
    }
    if (stageEl) {
      var scrollRAF = null;
      stageEl.addEventListener('scroll', function () {
        if (scrollRAF || !mqMobile.matches) return;
        scrollRAF = requestAnimationFrame(function () {
          scrollRAF = null;
          var vis = stageMediaVisible();
          if (!vis.length) return;
          var center = stageEl.scrollLeft + stageEl.clientWidth / 2;
          var best = vis[0], bestDist = Infinity;
          vis.forEach(function (el) {
            var mid = (el.offsetLeft - stageEl.offsetLeft) + el.offsetWidth / 2;
            var dist = Math.abs(mid - center);
            if (dist < bestDist) { bestDist = dist; best = el; }
          });
          markActive(best.getAttribute('data-sv-media-id'));
        });
      }, { passive: true });
    }

    update();

    // AJAX add-to-cart -> render Dawn cart drawer
    if (form) {
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return; // fall back to native form POST (redirect to /cart)
        e.preventDefault();
        if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.classList.add('is-loading'); }
        var body = {
          items: bundleItems(),
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        };
        fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (state) {
          if (state.status) { // error
            if (addText) addText.textContent = 'Add to Bag';
            return;
          }
          if (typeof drawer.renderContents === 'function' && state.sections) {
            drawer.renderContents(state);
          } else {
            window.location = (window.Shopify.routes.root || '/') + 'cart';
          }
        }).catch(function () {
          window.location = (window.Shopify.routes.root || '/') + 'cart';
        }).finally(function () {
          if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.classList.remove('is-loading'); }
        });
      });
    }

    // Size Guide dialog — bind every "Size Guide" / "View Size Guide" trigger
    // (there are two: next to the size label and inside the accordion).
    var sizeBtns = root.querySelectorAll('[data-sv-sizeguide-open]');
    var sizeDialog = root.querySelector('[data-sv-sizeguide]');
    if (sizeBtns.length && sizeDialog) {
      function openSizeGuide() {
        if (typeof sizeDialog.showModal === 'function') sizeDialog.showModal();
        else sizeDialog.setAttribute('open', '');
      }
      function closeSizeGuide() {
        if (typeof sizeDialog.close === 'function') sizeDialog.close();
        else sizeDialog.removeAttribute('open');
      }
      sizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); openSizeGuide(); });
      });
      sizeDialog.addEventListener('click', function (e) {
        // backdrop click or clicking the close button (or the icon inside it)
        if (e.target === sizeDialog || e.target.closest('[data-sv-sizeguide-close]')) {
          closeSizeGuide();
        }
      });
    }

    // Delivery estimator — validate a 6-digit Indian PIN code and show an
    // estimated delivery date (dispatch + transit business days). Real courier
    // serviceability requires a Shiprocket/API integration; this is an estimate.
    var dc = root.querySelector('[data-sv-deliverycheck]');
    if (dc) {
      var pinInput = dc.querySelector('[data-sv-pin]');
      var pinBtn = dc.querySelector('[data-sv-pin-check]');
      var pinResult = dc.querySelector('[data-sv-pin-result]');
      var dispatchDays = parseInt(dc.getAttribute('data-dispatch'), 10);
      var transitDays = parseInt(dc.getAttribute('data-transit'), 10);
      if (isNaN(dispatchDays)) dispatchDays = 2;
      if (isNaN(transitDays)) transitDays = 5;

      function addBusinessDays(from, days) {
        var d = new Date(from.getTime());
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          var day = d.getDay();
          if (day !== 0 && day !== 6) added++; // skip Sun/Sat
        }
        return d;
      }
      function checkPin() {
        var pin = (pinInput.value || '').replace(/\D/g, '');
        if (pin.length !== 6) {
          pinResult.hidden = false;
          pinResult.classList.remove('is-ok');
          pinResult.classList.add('is-err');
          pinResult.textContent = 'Please enter a valid 6-digit PIN code.';
          return;
        }
        var eta = addBusinessDays(new Date(), dispatchDays + transitDays);
        var opts = { weekday: 'long', day: 'numeric', month: 'short' };
        var label;
        try { label = eta.toLocaleDateString('en-IN', opts); }
        catch (e) { label = eta.toDateString(); }
        pinResult.hidden = false;
        pinResult.classList.remove('is-err');
        pinResult.classList.add('is-ok');
        pinResult.innerHTML = '✓ Estimated delivery to <strong>' + pin +
          '</strong> by <strong>' + label + '</strong>';
      }
      if (pinBtn) pinBtn.addEventListener('click', checkPin);
      if (pinInput) {
        pinInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); checkPin(); }
        });
      }
    }

    // Full-screen image lightbox — click (or Enter/Space) on a gallery image
    // opens it full screen; arrows / prev-next cycle the current colour's photos.
    var gallery = root.querySelector('[data-sv-gallery]');
    var lightbox = root.querySelector('[data-sv-lightbox]');
    if (gallery && lightbox) {
      var lbImg = lightbox.querySelector('[data-sv-lightbox-img]');
      var lbCount = lightbox.querySelector('[data-sv-lightbox-count]');
      var lbPrev = lightbox.querySelector('[data-sv-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-sv-lightbox-next]');
      var lbClose = lightbox.querySelector('[data-sv-lightbox-close]');
      var lbItems = [];
      var lbIndex = 0;

      function visibleZoomables() {
        return Array.prototype.slice.call(gallery.querySelectorAll('[data-sv-zoomable]'))
          .filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      }
      function renderLb() {
        var item = lbItems[lbIndex];
        if (!item) return;
        lbImg.setAttribute('src', item.src);
        lbImg.setAttribute('alt', item.alt || '');
        var multi = lbItems.length > 1;
        if (lbPrev) lbPrev.hidden = !multi;
        if (lbNext) lbNext.hidden = !multi;
        if (lbCount) lbCount.textContent = multi ? (lbIndex + 1) + ' / ' + lbItems.length : '';
      }
      function openLb(fromEl) {
        var els = visibleZoomables();
        if (!els.length) return;
        lbItems = els.map(function (el) {
          return { src: el.getAttribute('data-sv-zoom-src'), alt: el.getAttribute('data-sv-zoom-alt') };
        });
        var idx = els.indexOf(fromEl);
        lbIndex = idx < 0 ? 0 : idx;
        renderLb();
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
        else lightbox.setAttribute('open', '');
      }
      function closeLb() {
        if (typeof lightbox.close === 'function') lightbox.close();
        else lightbox.removeAttribute('open');
      }
      function step(delta) {
        if (lbItems.length < 2) return;
        lbIndex = (lbIndex + delta + lbItems.length) % lbItems.length;
        renderLb();
      }

      gallery.addEventListener('click', function (e) {
        var el = e.target.closest('[data-sv-zoomable]');
        if (el && gallery.contains(el)) { e.preventDefault(); openLb(el); }
      });
      gallery.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var el = e.target.closest('[data-sv-zoomable]');
        if (el && gallery.contains(el)) { e.preventDefault(); openLb(el); }
      });
      if (lbPrev) lbPrev.addEventListener('click', function () { step(-1); });
      if (lbNext) lbNext.addEventListener('click', function () { step(1); });
      if (lbClose) lbClose.addEventListener('click', closeLb);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('sv-lightbox__stage')) closeLb();
      });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-sv-pdp]').forEach(initPDP);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
